export const DashboardIcon = ({
  fill = 'white',
  width = '20',
  height = '20',
  viewBox = '0 0 20 20',
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      // eslint-disable-next-line max-len
      d="M7.74359 3.4359C7.74359 3.32261 7.65175 3.23077 7.53846 3.23077H3.4359C3.32261 3.23077 3.23077 3.32261 3.23077 3.4359V9.17949C3.23077 9.29278 3.32261 9.38462 3.4359 9.38462H7.53846C7.65175 9.38462 7.74359 9.29278 7.74359 9.17949V3.4359ZM8.97436 9.17949C8.97436 9.97251 8.33149 10.6154 7.53846 10.6154H3.4359C2.64287 10.6154 2 9.97251 2 9.17949V3.4359C2 2.64287 2.64287 2 3.4359 2H7.53846C8.33149 2 8.97436 2.64287 8.97436 3.4359V9.17949Z"
      fill={fill}
    />
    <path
      // eslint-disable-next-line max-len
      d="M16.7692 3.4359C16.7692 3.32261 16.6774 3.23077 16.5641 3.23077H12.4615C12.3482 3.23077 12.2564 3.32261 12.2564 3.4359V5.89744C12.2564 6.01073 12.3482 6.10256 12.4615 6.10256H16.5641C16.6774 6.10256 16.7692 6.01073 16.7692 5.89744V3.4359ZM18 5.89744C18 6.69046 17.3571 7.33333 16.5641 7.33333H12.4615C11.6685 7.33333 11.0256 6.69046 11.0256 5.89744V3.4359C11.0256 2.64287 11.6685 2 12.4615 2H16.5641C17.3571 2 18 2.64287 18 3.4359V5.89744Z"
      fill={fill}
    />
    <path
      // eslint-disable-next-line max-len
      d="M16.7692 10.8205C16.7692 10.7072 16.6774 10.6154 16.5641 10.6154H12.4615C12.3482 10.6154 12.2564 10.7072 12.2564 10.8205V16.5641C12.2564 16.6774 12.3482 16.7692 12.4615 16.7692H16.5641C16.6774 16.7692 16.7692 16.6774 16.7692 16.5641V10.8205ZM18 16.5641C18 17.3571 17.3571 18 16.5641 18H12.4615C11.6685 18 11.0256 17.3571 11.0256 16.5641V10.8205C11.0256 10.0275 11.6685 9.38462 12.4615 9.38462H16.5641C17.3571 9.38462 18 10.0275 18 10.8205V16.5641Z"
      fill={fill}
    />
    <path
      // eslint-disable-next-line max-len
      d="M7.74359 14.1026C7.74359 13.9893 7.65175 13.8974 7.53846 13.8974H3.4359C3.32261 13.8974 3.23077 13.9893 3.23077 14.1026V16.5641C3.23077 16.6774 3.32261 16.7692 3.4359 16.7692H7.53846C7.65175 16.7692 7.74359 16.6774 7.74359 16.5641V14.1026ZM8.97436 16.5641C8.97436 17.3571 8.33149 18 7.53846 18H3.4359C2.64287 18 2 17.3571 2 16.5641V14.1026C2 13.3095 2.64287 12.6667 3.4359 12.6667H7.53846C8.33149 12.6667 8.97436 13.3095 8.97436 14.1026V16.5641Z"
      fill={fill}
    />
  </svg>
)
